import { useCallback } from 'react';

const useDecodeHtml = () => {
    return useCallback((htmlString) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');
        return doc.documentElement.textContent;
    }, []);
};

export default useDecodeHtml;
